"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Collapse = void 0;
var dom_helpers_1 = require("../util/dom-helpers");
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var classnames_1 = require("../util/classnames");
var react_overlays_1 = require("../react-overlays");
var create_chained_function_1 = __importDefault(require("../util/create-chained-function"));
var _1 = require("../util/_");
var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.substr(1);
};
// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
var triggerBrowserReflow = function triggerBrowserReflow(node) {
  return node.offsetHeight;
};
var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
};
function getDimensionValue(dimension, elem) {
  var value = elem["offset" + capitalize(dimension)];
  var margins = MARGINS[dimension];
  return value + parseInt(dom_helpers_1.getCss(elem, margins[0]), 10) + parseInt(dom_helpers_1.getCss(elem, margins[1]), 10);
}
var Collapse = /** @class */function (_super) {
  __extends(Collapse, _super);
  function Collapse() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /* -- Expanding -- */
    _this.handleEnter = function (elem) {
      var dimension = _this._dimension();
      elem.style[dimension] = '0';
    };
    _this.handleEntering = function (elem) {
      var dimension = _this._dimension();
      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };
    _this.handleEntered = function (elem) {
      var dimension = _this._dimension();
      elem.style[dimension] = '';
    };
    /* -- Collapsing -- */
    _this.handleExit = function (elem) {
      var dimension = _this._dimension();
      var getDimensionValue = _this.props.getDimensionValue;
      elem.style[dimension] = getDimensionValue(dimension, elem) + 'px';
    };
    _this.handleExiting = function (elem) {
      var dimension = _this._dimension();
      triggerBrowserReflow(elem);
      elem.style[dimension] = '0';
    };
    _this._dimension = function () {
      return typeof _this.props.dimension === 'function' ? _this.props.dimension() : _this.props.dimension;
    };
    // for testing
    _this._getTransitionInstance = function () {
      return _this.transition;
    };
    _this._getScrollDimensionValue = function (elem, dimension) {
      return elem["scroll" + capitalize(dimension)] + 'px';
    };
    return _this;
  }
  Collapse.prototype.render = function () {
    var _this = this;
    var enter = create_chained_function_1.default(this.handleEnter, this.props.onEnter);
    var entering = create_chained_function_1.default(this.handleEntering, this.props.onEntering);
    var entered = create_chained_function_1.default(this.handleEntered, this.props.onEntered);
    var exit = create_chained_function_1.default(this.handleExit, this.props.onExit);
    var exiting = create_chained_function_1.default(this.handleExiting, this.props.onExiting);
    var transitionProps = _1.splitComponentProps(this.props, react_overlays_1.Transition)[0];
    return react_1.default.createElement(react_overlays_1.Transition, __assign({
      ref: function ref(c) {
        _this.transition = c;
      }
    }, transitionProps, {
      "aria-expanded": this.props.role ? this.props.in : null,
      className: classnames_1.classNames(this.props.className, {
        width: this._dimension() === 'width'
      }),
      exitedClassName: this.props.exitedClassName,
      exitingClassName: this.props.exitingClassName,
      enteredClassName: this.props.enteredClassName,
      enteringClassName: this.props.enteringClassName,
      onEnter: enter,
      onEntering: entering,
      onEntered: entered,
      onExit: exit,
      onExiting: exiting,
      onExited: this.props.onExited
    }), this.props.children);
  };
  // Explicitly copied from Transition for doc generation.
  Collapse.propTypes = {
    /**
     * Show the component; triggers the expand or collapse animation
     */
    in: prop_types_1.default.bool,
    /**
     * Unmount the component (remove it from the DOM) when it is collapsed
     */
    unmountOnExit: prop_types_1.default.bool,
    /**
     * Run the expand animation when the component mounts, if it is initially
     * shown
     */
    transitionAppear: prop_types_1.default.bool,
    /**
     * Duration of the collapse animation in milliseconds, to ensure that
     * finishing callbacks are fired even if the original browser transition end
     * events are canceled
     */
    timeout: prop_types_1.default.number,
    /**
     * Callback fired before the component expands
     */
    onEnter: prop_types_1.default.func,
    /**
     * Callback fired after the component starts to expand
     */
    onEntering: prop_types_1.default.func,
    /**
     * Callback fired after the component has expanded
     */
    onEntered: prop_types_1.default.func,
    /**
     * Callback fired before the component collapses
     */
    onExit: prop_types_1.default.func,
    /**
     * Callback fired after the component starts to collapse
     */
    onExiting: prop_types_1.default.func,
    /**
     * Callback fired after the component has collapsed
     */
    onExited: prop_types_1.default.func,
    /**
     * The dimension used when collapsing, or a function that returns the
     * dimension
     *
     * _Note: Bootstrap only partially supports 'width'!
     * You will need to supply your own CSS animation for the `.width` CSS class._
     */
    dimension: prop_types_1.default.oneOfType([prop_types_1.default.oneOf(['height', 'width']), prop_types_1.default.func]),
    /**
     * Function that returns the height or width of the animating DOM node
     *
     * Allows for providing some custom logic for how much the Collapse component
     * should animate in its specified dimension. Called with the current
     * dimension prop value and the DOM node.
     */
    getDimensionValue: prop_types_1.default.func,
    /**
     * ARIA role of collapsible element
     */
    role: prop_types_1.default.string,
    className: prop_types_1.default.string,
    children: prop_types_1.default.node,
    enteringClassName: prop_types_1.default.string,
    enteredClassName: prop_types_1.default.string,
    exitingClassName: prop_types_1.default.string,
    exitedClassName: prop_types_1.default.string
  };
  Collapse.defaultProps = {
    in: false,
    timeout: 300,
    unmountOnExit: false,
    transitionAppear: false,
    dimension: 'height',
    getDimensionValue: getDimensionValue
  };
  return Collapse;
}(react_1.default.Component);
exports.Collapse = Collapse;